export default __webpack_public_path__ + "static/media/logo.7744e3f2.png";